// import axios from "axios";
// import authService from '../../../Services/authService';

// const API_KEY = "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";


// // Convert image file to Base64
// const convertImageToBase64 = (file) => {
//     return new Promise((resolve, reject) => {
//         const reader = new FileReader();
//         reader.readAsDataURL(file);
//         reader.onload = () => resolve(reader.result); // Base64 encoded image
//         reader.onerror = (error) => reject(error);
//     });
// };

// // Convert PDF to multiple images using an external API or local tool
// const convertPdfToImage = async (file) => {
//     const formData = new FormData();
//     formData.append("pdf", file);

//     try {
//         const response = await axios.post(authService.getApiUrl() + "convert-pdf-to-image", formData, {
//             headers: { "Content-Type": "multipart/form-data" },
//         });

//         return response.data; // ✅ Returns full response object with multiple images
//     } catch (error) {
//         console.error("Error converting PDF:", error);
//         return null;
//     }
// };

// // Process Prescription File (PDF or Image)
// const processPrescriptionFile = async (file) => {
//     try {
//         let imageUrls = [];

//         if (file.type === "application/pdf") {
//             console.log("PDF detected, converting to images...");
//             const pdfResponse = await convertPdfToImage(file);
//             if (!pdfResponse || !pdfResponse.images || pdfResponse.images.length === 0) {
//                 return "Error: Unable to convert PDF to images.";
//             }
//             imageUrls = pdfResponse.images; // ✅ Use all images from the API response
//         } else {
//             console.log("Image detected, converting to Base64...");
//             const base64Image = await convertImageToBase64(file);
//             //imageUrls.push(base64Image); // ✅ Single image
//             const imageContent = [{
//                 type: "image",
//                 image: base64Image, // Pass Base64 string instead of URL
//               }];
//         }

//         if (imageUrls.length === 0) return "Error: Could not process file.";

//         // Prepare image URLs in OpenAI format
//         const imageContent = imageUrls.map((url) => ({
//             type: "image_url",
//             image_url: { url },
//         }));
        
//         const response = await axios.post(
//             "https://api.openai.com/v1/chat/completions",
//             {
//                 model: "gpt-4o",
//                 messages: [
//                     { role: "system", content: "You are a helpful assistant that extracts and interprets prescription details from images." },
//                     {
//                         role: "user",
//                         content: [
//                             { type: "text", text: "Extract and analyze this prescription:" },
//                             ...imageContent, // ✅ Now contains Base64 images
//                         ],
//                     },
//                 ],
//                 max_tokens: 1000,
//             },
//             {
//                 headers: {
//                     "Authorization": `Bearer ${API_KEY}`,
//                     "Content-Type": "application/json",
//                 },
//             }
//         );
        
//         // const response = await axios.post(
//         //     "https://api.openai.com/v1/chat/completions",
//         //     {
//         //         model: "gpt-4o",
//         //         messages: [
//         //             { role: "system", content: "You are a helpful assistant that extracts and interprets prescription details from images." },
//         //             {
//         //                 role: "user",
//         //                 content: [
//         //                     { type: "text", text: "Extract and analyze this prescription:" },
//         //                     ...imageContent, // ✅ Includes multiple images
//         //                 ],
//         //             },
//         //         ],
//         //         max_tokens: 1000, // Increase for multi-image processing
//         //     },
//         //     {
//         //         headers: {
//         //             "Authorization": `Bearer ${API_KEY}`,
//         //             "Content-Type": "application/json",
//         //         },
//         //     }
//         // );

//         return response.data.choices[0].message.content;
//     } catch (error) {
//         console.error("Error processing prescription:", error.response?.data || error.message);
//         return "Error processing the file.";
//     }
// };

// export default processPrescriptionFile;


import axios from "axios";
import authService from '../../../Services/authService';

const API_KEY = "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";

// Convert image file to Base64
const convertImageToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result); // Base64 encoded image
        reader.onerror = (error) => reject(error);
    });
};

// Convert PDF to multiple images using an external API or local tool
const convertPdfToImage = async (file) => {
    const formData = new FormData();
    formData.append("pdf", file);

    try {
        const response = await axios.post(authService.getApiUrl() + "convert-pdf-to-image", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });

        return response.data; // ✅ Returns full response object with multiple images
    } catch (error) {
        console.error("Error converting PDF:", error);
        return null;
    }
};

// Process Prescription File (PDF or Image)
const processPrescriptionFile = async (file) => {
    try {
        let imageUrls = [];

        if (file.type === "application/pdf") {
            console.log("PDF detected, converting to images...");
            const pdfResponse = await convertPdfToImage(file);
            if (!pdfResponse || !pdfResponse.images || pdfResponse.images.length === 0) {
                return "Error: Unable to convert PDF to images.";
            }
            imageUrls = pdfResponse.images.map((url) => ({
                type: "image_url",
                image_url: { url },
            })); // ✅ Ensure URLs are wrapped in an object
        } else if (file.type.startsWith("image/")) {
            console.log("Image detected, converting to Base64...");
            const base64Image = await convertImageToBase64(file);

            // ✅ Ensure Base64 string is properly wrapped inside an "image_url" object
            imageUrls.push({
                type: "image_url",
                image_url: { url: base64Image },
            });
        } else {
            return "Error: Unsupported file type.";
        }

        if (imageUrls.length === 0) return "Error: Could not process file.";

        console.log("Sending images to OpenAI API:", imageUrls);

        const response = await axios.post(
            "https://api.openai.com/v1/chat/completions",
            {
                model: "gpt-4o",
                messages: [
                    { role: "system", content: "You are a helpful assistant that extracts and interprets prescription details from images." },
                    {
                        role: "user",
                        content: [
                            { type: "text", text: "Extract and analyze this prescription:" },
                            ...imageUrls, // ✅ Now properly formatted
                        ],
                    },
                ],
                max_tokens: 1000,
            },
            {
                headers: {
                    "Authorization": `Bearer ${API_KEY}`,
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data.choices[0].message.content;
    } catch (error) {
        console.error("Error processing prescription:", error.response?.data || error.message);
        return "Error processing the file.";
    }
};

export default processPrescriptionFile;

